import { z } from 'zod';
import { getCardPositionDtoSchema } from '../getCardPositionDtoSchema';

export const cardsControllerChangePosition200Schema = z.array(
  z.lazy(() => getCardPositionDtoSchema),
);

export const cardsControllerChangePosition400Schema = z.union([
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['SamePosition']),
    details: z.enum(['null']).nullable(),
  }),
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['PositionExceedsMaximum']),
    details: z.object({
      providedValue: z.number().int().min(1),
      maximum: z.number().int().min(1),
    }),
  }),
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['InvalidData']),
    details: z.object({
      location: z.enum(['path', 'query', 'body']),
      explanation: z.object({
        issues: z.array(
          z
            .object({
              code: z.enum([
                'invalid_type',
                'invalid_literal',
                'custom',
                'invalid_union',
                'invalid_union_discriminator',
                'invalid_enum_value',
                'unrecognized_keys',
                'invalid_arguments',
                'invalid_return_type',
                'invalid_date',
                'invalid_string',
                'too_small',
                'too_big',
                'invalid_intersection_types',
                'not_multiple_of',
                'not_finite',
              ]),
              path: z.array(z.union([z.string(), z.number()])),
              message: z.string(),
            })
            .catchall(z.unknown()),
        ),
      }),
    }),
  }),
]);

export const cardsControllerChangePosition401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const cardsControllerChangePosition403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const cardsControllerChangePosition404Schema = z.object({
  statusCode: z.enum(['404']),
  message: z.string(),
  type: z.enum(['ObjectNotFound']),
  details: z.enum(['null']).nullable(),
});

export const cardsControllerChangePositionMutationRequestSchema = z.object({
  id: z.string().uuid(),
  position: z.number().int().min(1),
});

export const cardsControllerChangePositionMutationResponseSchema = z.array(
  z.lazy(() => getCardPositionDtoSchema),
);
